import { SOURCE_TYPES } from '@repo/food-engine'
import type { Language } from './schemas/simulation'

/**
 * 근거 꼬리표 (대표 명세 P1-03 '근거 표시', 2026-10-30 Top5 #2). 결과 화면·제품 검토 리포트·사양서의 주요 숫자마다 이 값
 * 하나를 붙여 어디서 온 숫자인지 보인다. 여기 한 곳에서만 정하고 다른 곳은 import 한다.
 * - user_input 사용자가 넣은 값 · calculated 계산 코드가 낸 값 · ai_estimated AI 추정(시식·측정 전)
 * - measured 실측 · sensory_panel 시식 기록 · supplier_quote 공급사·공장 견적
 * 자료가 없으면 꼬리표 대신 unconfirmed(미확인)를 쓴다 — 빈 값을 0 이나 추정으로 메우지 않는다.
 */
// 꼬리표 6종은 공통 계산 엔진(packages/food-engine/src/evidence.ts)이 원본이다. 엔진이 계산값에 붙이는 것과 같은 값
export { SOURCE_TYPES, type SourceType } from '@repo/food-engine'

/** 근거 꼬리표 + 미확인. 화면·저장 모두 이 값을 쓴다 */
export const SOURCE_TAGS = [...SOURCE_TYPES, 'unconfirmed'] as const
export type SourceTag = (typeof SOURCE_TAGS)[number]

/**
 * 화면에서 꼬리표를 그리는 무리. AI 추정과 실제 확인(실측·시식·견적)을 한눈에 가르려고 색과 선을 나눈다
 * - observed: 실측·시식·견적 (채운 칸) · entered: 사용자 입력 · calculated: 계산
 * - estimate: AI 추정 (점선 테두리) · unconfirmed: 미확인 (흐린 글자)
 */
export type SourceTone = 'observed' | 'entered' | 'calculated' | 'estimate' | 'unconfirmed'
export const SOURCE_TONE: Record<SourceTag, SourceTone> = {
  user_input: 'entered',
  calculated: 'calculated',
  ai_estimated: 'estimate',
  measured: 'observed',
  sensory_panel: 'observed',
  supplier_quote: 'observed',
  unconfirmed: 'unconfirmed',
}

/** 꼬리표 글자 (짧게: 숫자 옆 작은 칸에 들어간다) */
export const SOURCE_TAG_COPY: Record<Language, Record<SourceTag, string>> = {
  ko: {
    user_input: '직접 입력',
    calculated: '계산',
    ai_estimated: '추정',
    measured: '실측',
    sensory_panel: '시식 기록',
    supplier_quote: '공급사 견적',
    unconfirmed: '미확인',
  },
  en: {
    user_input: 'Entered',
    calculated: 'Calculated',
    ai_estimated: 'Estimate',
    measured: 'Measured',
    sensory_panel: 'Tasting record',
    supplier_quote: 'Supplier quote',
    unconfirmed: 'Unconfirmed',
  },
  ja: {
    user_input: '入力値',
    calculated: '計算',
    ai_estimated: '推定',
    measured: '実測',
    sensory_panel: '試食記録',
    supplier_quote: '仕入先見積',
    unconfirmed: '未確認',
  },
  zh: {
    user_input: '用户输入',
    calculated: '计算',
    ai_estimated: '估算',
    measured: '实测',
    sensory_panel: '试吃记录',
    supplier_quote: '供应商报价',
    unconfirmed: '未确认',
  },
}
